module.exports = __webpack_public_path__ + "static/media/lotusLogoNew.ff26643a.png";